import * as React from 'react'

export default function useLiveRef(value) {
  const ref = React.useRef(value)
  React.useLayoutEffect(() => {
    ref.current = value
  })
  return ref
}
